"use strict";
/**
 * Created by Ning Jiang on 2021-06-17.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitmapCountUp = void 0;
const gsap_1 = require("gsap");
const SlotGame_1 = require("../SlotGame");
class BitmapCountUp extends PIXI.BitmapText {
    get maxTextWidth() {
        return this._maxTextWidth;
    }
    set maxTextWidth(value) {
        this._maxTextWidth = value;
        if (this.parent) {
            this.updateCountUpTextPivot();
        }
        else {
            this._isResizeDirty = true;
        }
    }
    // @ts-ignore - this is declared as a property in pixi ts definitions. But it is in fact accessors and should be overridable like this. But Typescript 5 complains
    get width() {
        return this.textWidth;
    }
    constructor(style) {
        super("", style);
        this._isResizeDirty = false;
        this.evenCharWidth = true;
        this._maxTextWidth = 720;
        this._originalFontSize = style.fontSize;
        this._isResizeDirty = true;
        this.on("added", this.onAdded);
    }
    onAdded() {
        if (this._isResizeDirty) {
            this.updateCountUpTextPivot();
        }
    }
    getCountUpAnimation(fromValue, toValue, duration, ease = "none") {
        var _a, _b;
        const tl = (_a = gsap_1.gsap.timeline) === null || _a === void 0 ? void 0 : _a.call(gsap_1.gsap);
        tl.add((_b = gsap_1.gsap.fromTo) === null || _b === void 0 ? void 0 : _b.call(gsap_1.gsap, this, { currentValue: fromValue }, {
            duration: duration,
            currentValue: toValue,
            ease: ease,
            onStart: () => {
                if (this.shrinkSize) {
                    this.fontSize = this._originalFontSize;
                    //this.updateText(); // removed in PIXI v5
                }
                this.onCountUpUpdate();
                this.updateCountUpTextPivot();
            },
            onUpdate: () => this.onCountUpUpdate(),
            onComplete: () => {
                this.onCountUpUpdate();
            }
        }));
        return tl;
    }
    onCountUpUpdate() {
        const lastStringLength = this.text.length;
        this.text = SlotGame_1.SlotGame.apiPlugin.currency.formatValue(this.currentValue);
        if (!this.evenCharWidth || lastStringLength != this.text.length) {
            this.updateCountUpTextPivot();
        }
    }
    updateCountUpTextPivot() {
        if (!this.parent) {
            this._isResizeDirty = true;
            return;
        }
        this.dirty = true;
        this.updateTransform(); //Force update transform so that the textWidth are updated.
        if (this.shrinkSize) {
            while (this.textWidth > this._maxTextWidth) {
                this.fontSize--;
                this.dirty = true;
                this.updateTransform();
            }
        }
        this.pivot.set(this.textWidth * 0.5, this.textHeight * 0.5);
        this._isResizeDirty = false;
    }
}
exports.BitmapCountUp = BitmapCountUp;
//# sourceMappingURL=BitmapCountUp.js.map